"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.testStatementPosition = void 0;
const data_1 = require("@grafana/data");
const Monaco_1 = require("../mocks/Monaco");
const TextModel_1 = require("../mocks/TextModel");
const getStatementPosition_1 = require("../standardSql/getStatementPosition");
const linkedTokenBuilder_1 = require("../utils/linkedTokenBuilder");
function assertPosition(query, position, expected, monacoMock, resolversRegistry) {
    const testModel = (0, TextModel_1.TextModel)(query);
    const current = (0, linkedTokenBuilder_1.linkedTokenBuilder)(monacoMock, testModel, position);
    const statementPosition = (0, getStatementPosition_1.getStatementPosition)(current, resolversRegistry);
    expect(statementPosition).toContain(expected);
}
const testStatementPosition = (expected, cases, resolvers) => {
    describe(`${expected}`, () => {
        let MonacoMock;
        let statementPositionResolversRegistry;
        beforeEach(() => {
            const mockQueries = new Map();
            cases.forEach((c) => mockQueries.set(c.query.query, c.query.tokens));
            MonacoMock = (0, Monaco_1.getMonacoMock)(mockQueries);
            statementPositionResolversRegistry = new data_1.Registry(() => {
                return resolvers().map((r) => ({
                    id: r.id,
                    name: r.name || r.id,
                    resolve: r.resolve,
                }));
            });
        });
        // using forEach here rather than test.each as been struggling to get the arguments interpolated in test name string
        cases.forEach((c) => {
            test(`${c.query.query}`, () => {
                assertPosition(c.query.query, { lineNumber: c.position.line, column: c.position.column }, expected, MonacoMock, statementPositionResolversRegistry);
            });
        });
    });
};
exports.testStatementPosition = testStatementPosition;
//# sourceMappingURL=statementPosition.js.map